/**
 * Seta os erros no estado do front, através do retorno do backend {data}
 *
 * @todo Realizar testes com retorno de data maior que 1 item no array,
 * talvez não funcione bem a remoção dos dados já validados na linha 27
 *
 * @param {array} data
 * @param {Object} errors
 * @param {Function} setErrors
 */
const setErrorMessageInInputs = (data, errors, setErrors) => {

    data.map((item) => {

        // Setando errors
        if (item.memberNames && item.memberNames.length > 0) {
            item.memberNames.forEach((memberName) => {
                if (errors[memberName] !== undefined) {
                    const copyErrors = { ...errors };
                    copyErrors[memberName] = item.errorMessage;
                    copyErrors["hasError"] = true;
                    setErrors(copyErrors);
                }
            })

            // Removendo dados já validados
            const keys = Object.keys(errors);
            keys.forEach(key => {
                if (!item.memberNames.includes(key) && key !== "hasError") {
                    const newCopyErrors = { ...errors };
                    newCopyErrors[key] = "";
                    setErrors(newCopyErrors);
                }
            })
        }

        return item;
    });

    if (data.length === 0) {
        setErrors({ ...errors, hasError: false });
    }

    if (data.length === 1 && data[0].memberNames && data[0].memberNames.length === 0) {
        Object.keys(errors).forEach(key => {
            if (key !== "hasError") {
                const newCopyErrors = { ...errors };
                newCopyErrors[key] = "";
                setErrors(newCopyErrors);
            }
        })
    }
}

export { setErrorMessageInInputs };
